module.exports = __webpack_public_path__ + "static/media/elearning2.8c05c7ff.jpg";